
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenRecording as ObiScreenRecordingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-recording.js';
 
 
 

 
 export const ObiScreenRecording = createComponent({
   react: React,
   tagName: 'obi-screen-recording',
   elementClass: ObiScreenRecordingElement,
   events: {
     
   }
  });
 
 